import { createDecorator } from '../../instantiation/common/instantiation.js';
const IExtensionsProfileScannerService = ( createDecorator('IExtensionsProfileScannerService'));
export { IExtensionsProfileScannerService };
